import React from "react";

import { OverallPhaseScore as OverallPhaseScoreComponent } from "heat-next";

import { useSessionDetailsContext } from "@/context/session-details/session-details";

import { ComponentWrapper } from "@/pages/shared/shared.styles";

import ContentLoader from "@/components/content-loader/content-loader";
import EmptyState from "@/components/empty-state/empty-state";
import { EmptyStateType } from "@/components/empty-state/empty-state.types";

const OverallPhaseScore = () => {
    const { overallPhaseScoreData, isFetchingOverallPhaseScore, isErrorOverallPhaseScore } =
        useSessionDetailsContext();

    const overallScoreDataset = overallPhaseScoreData?.[0].datasets?.[0];

    const isEmptyState =
        !isErrorOverallPhaseScore &&
        (overallPhaseScoreData === null ||
            overallScoreDataset?.length === 0 ||
            overallPhaseScoreData?.length === 0);

    if (isFetchingOverallPhaseScore) {
        return <ContentLoader height="21.1875rem" />;
    }

    if (isEmptyState) {
        return (
            <ComponentWrapper>
                <EmptyState
                    title="session-details:overall-phase-score:empty-state:title"
                    emptyStateType={EmptyStateType.Charts}
                    minHeight="18.1875rem"
                />
            </ComponentWrapper>
        );
    }

    if (isErrorOverallPhaseScore && !isFetchingOverallPhaseScore) {
        return (
            <ComponentWrapper>
                <EmptyState
                    title="error-state:title"
                    description="error-state:description"
                    emptyStateType={EmptyStateType.Error}
                    minHeight="18.1875rem"
                />
            </ComponentWrapper>
        );
    }

    return <OverallPhaseScoreComponent data={overallPhaseScoreData} />;
};

export default OverallPhaseScore;
